var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-message',{attrs:{"title":_vm.$t('Funcionalidad no disponible'),"type":"is-danger","has-icon":"","icon":"emoticon-sad","aria-close-label":"Close message"}},[_vm._v("\n    "+_vm._s(_vm.$t(
        'Esta funcionalidad no está disponible en tu plan actual. Para disfrutar de ella deberás contratar un plan superior.'
      ))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }